import m from "../../../../geodata/es2015/region/usa/okHigh";
window.am4geodata_region_usa_okHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/okHigh.js
// module id = null
// module chunks = 